const initialState = {
  layersResults: {},
  spatialResults: {},
  dataTableResults: {},
  featureInfoResults: {},
  favoriteResults: {},
  favoriteResultsFeatureIds: [],
  resultsPanelActiveTab: "layersResults",
  generalResults: {},
  cswResults: {},
};

export default function resultsPanelReducer(state = initialState, action) {
  switch (action.type) {
    case "loadconfiguration":
      {
        return {
          layersResults: {},
          spatialResults: {},
          dataTableResults: {},
          featureInfoResults: {},
          favoriteResults: {},
          favoriteResultsFeatureIds: [],
          resultsPanelActiveTab: "layersResults",
          generalResults: {},
        };
      }
      break;

    case "results/setActiveTab":
      {
        let newState = { ...state };

        setTimeout(window["recaclulatePerfectScrollbarHeight"], 0);

        newState.resultsPanelActiveTab = action.payload;

        return newState;
      }
      break;

    case "results/layersResults/add":
      {
        let newState = { ...state };

        if (!newState.layersResults[action.payload.id]) {
          newState.layersResults[action.payload.id] = [];
        }

        newState.layersResults[action.payload.id].push({
          data: action.payload.data,
          params: action.payload.params,
        });

        window["recaclulateResultsPanelHeight"]();
        newState.resultsPanelActiveTab = "layersResults";
        return newState;
      }
      break;

    case "results/layersResults/params/update":
      {
        let newState = { ...state };

        newState.layersResults[action.payload.id][action.payload.index][
          "params"
        ][action.payload.property] = action.payload.value;

        return newState;
      }
      break;

    case "results/layersResults/delete":
      {
        let newState = { ...state };

        delete newState.layersResults[action.payload.id];
        return newState;
      }

      break;

    case "results/layersResults/results/delete":
      {
        let newState = { ...state };

        newState.layersResults[action.payload.parentId].splice(
          action.payload.id,
          1
        );
        return newState;
      }

      break;

    case "results/spatialResults/add":
      {
        let newState = { ...state };

        if (!newState.spatialResults[action.payload.params.searchKey]) {
          newState.spatialResults[action.payload.params.searchKey] = [];
        }

        newState.spatialResults[action.payload.params.searchKey].push({
          data: action.payload.data,
          params: action.payload.params,
          layer: action.payload.id,
        });
        window["recaclulateResultsPanelHeight"]();
        newState.resultsPanelActiveTab = "spatialResults";
        return newState;
      }
      break;

    case "results/spatialResults/delete":
      {
        let newState = { ...state };

        delete newState.spatialResults[action.payload.id];
        return newState;
      }

      break;

    case "results/spatialResults/params/update":
      {
        let newState = { ...state };

        newState.spatialResults[action.payload.id][action.payload.index][
          "params"
        ][action.payload.property] = action.payload.value;

        return newState;
      }
      break;

    case "results/spatialResults/results/delete":
      {
        let newState = { ...state };

        newState.spatialResults[action.payload.parentId].splice(
          action.payload.id,
          1
        );
        return newState;
      }

      break;

    case "results/featureInfoResults/add":
      {
        let newState = { ...state };

        if (!newState.featureInfoResults[action.payload.params.searchKey]) {
          newState.featureInfoResults[action.payload.params.searchKey] = [];
        }

        newState.featureInfoResults[action.payload.params.searchKey].push({
          data: action.payload.data,
          params: action.payload.params,
          layer: action.payload.id,
        });
        window["recaclulateResultsPanelHeight"]();
        newState.resultsPanelActiveTab = "featureInfoResults";
        return newState;
      }
      break;

    case "results/featureInfoResults/delete":
      {
        let newState = { ...state };

        delete newState.featureInfoResults[action.payload.id];
        return newState;
      }

      break;

    case "results/featureInfoResults/params/update":
      {
        let newState = { ...state };

        newState.featureInfoResults[action.payload.id][action.payload.index][
          "params"
        ][action.payload.property] = action.payload.value;

        return newState;
      }
      break;

    case "results/featureInfoResults/results/delete":
      {
        let newState = { ...state };

        newState.featureInfoResults[action.payload.parentId].splice(
          action.payload.id,
          1
        );
        return newState;
      }

      break;

    case "results/dataTableResults/update":
      {
        let newState = { ...state };

        if (!newState.dataTableResults[action.payload.id]) {
          newState.dataTableResults[action.payload.id] = {};
        }

        newState.dataTableResults[action.payload.id] = {
          data: action.payload.data,
          params: action.payload.params,
        };
        window["recaclulateResultsPanelHeight"]();
        newState.resultsPanelActiveTab = "datatableResults";
        return newState;
      }
      break;

    case "results/dataTableResults/params/update":
      {
        let newState = { ...state };

        newState.dataTableResults[action.payload.id]["params"][
          action.payload.property
        ] = action.payload.value;
        window["recaclulateResultsPanelHeight"]();
        newState.resultsPanelActiveTab = "datatableResults";
        return newState;
      }
      break;

    case "results/dataTableResults/delete":
      {
        let newState = { ...state };

        delete newState.dataTableResults[action.payload.id];

        return newState;
      }
      break;

    case "results/favoriteResults/update":
      {
        let newState = { ...state };

        if (!newState.favoriteResults[action.payload.id]) {
          newState.favoriteResults[action.payload.id] = { data: [] };
        }

        newState.favoriteResults[action.payload.id] = {
          data: action.payload.data,
        };
        window["recaclulateResultsPanelHeight"]();
        newState.resultsPanelActiveTab = "favoriteResults";
        return newState;
      }
      break;

    case "results/favoriteResults/add":
      {
        let newState = { ...state };

        if (!newState.favoriteResults[action.payload.id]) {
          newState.favoriteResults[action.payload.id] = { data: [] };
        }

        newState.favoriteResults[action.payload.id].data = [
          ...newState.favoriteResults[action.payload.id].data,
          action.payload.data,
        ];
        window["recaclulateResultsPanelHeight"]();
        newState.resultsPanelActiveTab = "favoriteResults";
        return newState;
      }
      break;

    case "results/favoriteResults/params/update":
      {
        let newState = { ...state };

        if (!newState.favoriteResults[action.payload.id]["params"]) {
          newState.favoriteResults[action.payload.id]["params"] = {};
        }

        newState.favoriteResults[action.payload.id]["params"][
          action.payload.property
        ] = action.payload.value;

        return newState;
      }
      break;

    case "results/favoriteResults/toggle":
      {
        let newState = { ...state };

        if (!newState.favoriteResults[action.payload.id]) {
          newState.favoriteResults[action.payload.id] = { data: [] };

          newState.favoriteResults[action.payload.id].data = [
            ...newState.favoriteResults[action.payload.id].data,
            { ...action.payload.data },
          ];

          newState.favoriteResultsFeatureIds.push(
            action.payload.data._featureId
          );
        } else {
          let favoriteIndex = null;
          newState.favoriteResults[action.payload.id]?.data.forEach(
            (favorite, idx) => {
              if (favorite._featureId === action.payload.data._featureId) {
                favoriteIndex = idx;
              }
            }
          );

          if (favoriteIndex !== null) {
            newState.favoriteResults[action.payload.id]?.data.splice(
              favoriteIndex,
              1
            );
            newState.favoriteResultsFeatureIds.splice(
              state.favoriteResultsFeatureIds.indexOf(
                action.payload.data._featureId
              ),
              1
            );
          } else {
            newState.favoriteResults[action.payload.id].data = [
              ...newState.favoriteResults[action.payload.id].data,
              { ...action.payload.data },
            ];
            newState.favoriteResultsFeatureIds.push(
              action.payload.data._featureId
            );
          }
        }
        return newState;
      }
      break;

    case "results/favoriteResults/delete":
      {
        let newState = { ...state };

        let _favoriteResultsFeatureIds = [];

        newState.favoriteResults[action.payload.id].data.forEach((el) => {
          if (!_favoriteResultsFeatureIds.indexOf(el._featureId)) {
            _favoriteResultsFeatureIds.push(el._featureId);
          }
        });

        newState.favoriteResultsFeatureIds = [..._favoriteResultsFeatureIds];

        delete newState.favoriteResults[action.payload.id];

        return newState;
      }
      break;

    case "results/cswResults/add":
      {
        let newState = { ...state };

        if (!newState.cswResults[action.payload.params.searchKey]) {
          newState.cswResults[action.payload.params.searchKey] = [];
        }

        newState.cswResults[action.payload.params.searchKey].push({
          data: action.payload.data,
          params: action.payload.params,
          source: action.payload.source,
        });
        window["recaclulateResultsPanelHeight"]();
        newState.resultsPanelActiveTab = "cswResults";
        return newState;
      }
      break;

    case "results/cswResults/delete":
      {
        let newState = { ...state };

        delete newState.cswResults[action.payload.id];
        return newState;
      }

      break;

    case "results/cswResults/params/update":
      {
        let newState = { ...state };

        newState.cswResults[action.payload.id][action.payload.index]["params"][
          action.payload.property
        ] = action.payload.value;

        return newState;
      }
      break;

    case "results/cswResults/results/delete":
      {
        let newState = { ...state };

        newState.cswResults[action.payload.parentId].splice(
          action.payload.id,
          1
        );
        return newState;
      }

      break;

    default:
      return state;
  }
}
